// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

import {
  Archive,
  BanknoteArrowUp,
  CheckCircle,
  CircleAlert,
  CircleCheck,
  CircleEllipsis,
  CircleQuestionMark,
  CircleSlash,
  Edit,
  FileBox,
  Flower2,
  Globe,
  HandCoins,
  Mail,
  MapPin,
  MapPinCheckInside,
  MapPinPlusInside,
  MessageSquare,
  Package,
  Package2,
  PackageCheck,
  PackageOpen,
  PackagePlus,
  PackageX,
  Phone,
  Printer,
  ReceiptText,
  ShoppingBasket,
  SquareArrowRight,
  SquareCheckBig,
  SquareDashed,
  Store,
  TagIcon,
  Truck,
  Undo,
  Undo2,
  WalletCards,
} from 'lucide-react'

export const ICONS = {
  Archive,
  BanknoteArrowUp,
  CheckCircle,
  CircleAlert,
  CircleCheck,
  CircleEllipsis,
  CircleQuestionMark,
  CircleSlash,
  Edit,
  FileBox,
  Flower2,
  Globe,
  HandCoins,
  Mail,
  MapPin,
  MapPinCheckInside,
  MapPinPlusInside,
  MessageSquare,
  Package,
  Package2,
  PackageCheck,
  PackageOpen,
  PackagePlus,
  PackageX,
  Phone,
  Printer,
  ReceiptText,
  ShoppingBasket,
  SquareArrowRight,
  SquareCheckBig,
  SquareDashed,
  Store,
  TagIcon,
  Truck,
  Undo,
  Undo2,
  WalletCards,
}
